import { motion } from "framer-motion";
import { MapPin, Check, Camera, Clock } from "lucide-react";

// Stylized field-ops app screen inside a brutalist phone frame
export const PhoneMock = () => {
  return (
    <div className="relative mx-auto w-[280px] sm:w-[320px]">
      {/* orange offset block behind */}
      <div className="absolute -right-5 -top-5 h-full w-full border-2 border-ink bg-orange halftone-ink" />
      <div className="relative border-2 border-ink bg-ink p-3 shadow-brutal-paper">
        {/* notch */}
        <div className="mx-auto mb-2 h-1.5 w-16 rounded-full bg-paper/30" />
        <div className="border-2 border-paper/20 bg-paper">
          {/* status bar */}
          <div className="flex items-center justify-between bg-ink px-4 py-2">
            <span className="font-mono text-[10px] uppercase tracking-widest text-paper">9:41</span>
            <span className="font-mono text-[10px] uppercase tracking-widest text-orange">On Shift</span>
          </div>

          {/* header */}
          <div className="border-b-2 border-ink px-4 py-4">
            <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-muted2">Today’s activation</p>
            <p className="font-bebas text-3xl leading-none tracking-tight text-ink">DOWNTOWN LA · GRID 04</p>
          </div>

          {/* check-in card */}
          <div className="p-4">
            <motion.div
              animate={{ y: [0, -4, 0] }}
              transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
              className="border-2 border-ink bg-cardwhite p-3 shadow-brutal-sm"
            >
              <div className="flex items-center gap-2">
                <div className="flex h-8 w-8 items-center justify-center border-2 border-ink bg-orange">
                  <MapPin size={16} className="text-paper" />
                </div>
                <div>
                  <p className="font-mono text-[10px] uppercase tracking-widest text-muted2">Geo-verified</p>
                  <p className="font-mono text-xs font-bold text-ink">Arts District · 0.1mi</p>
                </div>
              </div>
              <button className="mt-3 w-full bg-ink py-2 font-mono text-[11px] font-bold uppercase tracking-[0.2em] text-paper">
                Check in
              </button>
            </motion.div>

            {/* task list */}
            <div className="mt-4 space-y-2">
              {[
                { t: "Set up branded tent", done: true, icon: Check },
                { t: "Scan 25 samples", done: true, icon: Check },
                { t: "Upload proof photos", done: false, icon: Camera },
              ].map((task, i) => {
                const Icon = task.icon;
                return (
                  <div
                    key={i}
                    className={`flex items-center gap-2 border-2 border-ink px-3 py-2 ${
                      task.done ? "bg-paper" : "bg-orange"
                    }`}
                  >
                    <div
                      className={`flex h-5 w-5 items-center justify-center border-2 border-ink ${
                        task.done ? "bg-success" : "bg-cardwhite"
                      }`}
                    >
                      <Icon size={12} className={task.done ? "text-paper" : "text-ink"} />
                    </div>
                    <span
                      className={`font-mono text-[11px] ${
                        task.done ? "text-muted2 line-through" : "font-bold text-paper"
                      }`}
                    >
                      {task.t}
                    </span>
                  </div>
                );
              })}
            </div>

            {/* shift timer */}
            <div className="mt-4 flex items-center justify-between border-2 border-ink bg-ink px-3 py-2">
              <div className="flex items-center gap-2">
                <Clock size={14} className="text-orange" />
                <span className="font-mono text-[10px] uppercase tracking-widest text-paper">Shift</span>
              </div>
              <span className="font-bebas text-2xl leading-none text-paper">02:47:19</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
